import React from 'react';
import { SignupForm } from './SignupForm';
export function HeroSection() {
  return <main className="flex-grow flex items-center justify-center w-full px-4 py-12" data-id="element-10">
      <div className="container mx-auto max-w-4xl" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight text-[#133863]" data-id="element-13">
            Something <span className="text-[#1d4f8a]" data-id="element-14">extraordinary</span> is
            coming
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-15">
            We're building the next generation of AI-powered tools to transform
            how you work and the CRE industry. Join our waiting list for early access.
          </p>
          <div className="relative w-full max-w-md mx-auto" data-id="element-16">
            <div className="absolute -inset-1 bg-[#133863] rounded-lg blur opacity-20" data-id="element-17"></div>
            <div className="relative bg-white p-6 md:p-8 rounded-lg shadow-xl border border-gray-100" data-id="element-18">
              <h2 className="text-xl font-semibold mb-6 text-[#133863]" data-id="element-19">
                Get Early Access
              </h2>
              <SignupForm data-id="element-20" />
            </div>
          </div>
        </div>
      </div>
    </main>;
}